// The ONE definition of the unsubscribe link tag put in marketing email bodies.
// Shared by the server footer (server/lib/unsubscribeFooter.ts) and the
// {unsubscribe_link} broadcast slug (src/lib/broadcastSlugs.ts), so an
// author-placed link and an auto-appended one cannot disagree.
//
// ⚠️⚠️ THIS IS SENDGRID'S ASM *PREFERENCES* URL, NOT THE GROUP-UNSUBSCRIBE URL
// (<%asm_group_unsubscribe_raw_url%>). The group-unsubscribe URL acts on a GET:
// a delivery-time security scan that prefetches every URL in the message
// (Microsoft Defender and friends) would unsubscribe the client, just from one
// group. The preferences URL lands on a page where a human ticks a box and
// SUBMITS; a prefetch records nothing. That tag is the actual fix for the
// 2026-09-11 / 2026-10-14 mass-unsubscribes -- the suppression group only
// limits the damage if one ever gets through. Do not "simplify" it.
//
// ⚠️ It only resolves on a message that carries an `asm` group (see
// SendGridUnsubscribeGroup in server/lib/sendgrid.ts). On an ungrouped message
// SendGrid leaves it literal.
export const UNSUBSCRIBE_PREFERENCES_TAG = '<%asm_preferences_raw_url%>';

// ⚠️⚠️ WHY THE SLUG CANNOT RESOLVE TO THE TAG ITSELF. The {unsubscribe_link}
// slug is substituted into the authored MARKDOWN, which is then rendered and
// sanitised. The old tag ('[unsubscribe]') survived that; the ASM tag does not:
// marked escapes a bare `<%...%>` to `&lt;%...%&gt;` (SendGrid then never sees a
// tag) and strips the angle brackets from a link destination
// (`[x](<%asm_...%>)` -> href="%asm_...%"). Measured, not assumed.
//
// So the slug resolves to this plain-word placeholder, which every markdown
// position carries untouched, and the real tag is swapped in AFTER render +
// sanitise (server/lib/sanitizeHtml.ts renderBroadcastEmailHtml). Anything that
// renders markdown for sending must go through that function; the browser
// preview swaps in '#'.
export const UNSUBSCRIBE_SLUG_PLACEHOLDER = 'kyckunsubscribepreferenceslink';

export function swapUnsubscribePlaceholder(html: string, replacement: string): string {
  return html.split(UNSUBSCRIBE_SLUG_PLACEHOLDER).join(replacement);
}
